const FinalMessage = () => (
  <section className="bg-background py-24 sm:py-32">
    <div className="reading-column px-6 text-center">
      <p className="italic text-foreground/70">
        It took me a while to understand this.
      </p>
      <p className="mt-6 font-serif text-3xl leading-snug text-foreground sm:text-4xl md:text-5xl">
        You're not broken.
        <br />
        Your body just changed.
      </p>
      <p className="mt-8 font-serif text-xl italic text-foreground/80 sm:text-2xl">
        And you deserve to feel like yourself again.
      </p>
    </div>
  </section>
);

export default FinalMessage;
